module.exports = __webpack_public_path__ + "img/w1.41ff2932.jpg";